import { AlertHandler } from '@widergy/energy-ui';
import i18n from 'i18next';
import { normalizeByRegex } from '@widergy/web-utils/lib/normalize';

import { DIGITAL_BILL } from 'constants/routes';

export default {
  alertDialog: {
    dialogProps: {
      whiteTitle: true
    },
    textProps: {
      white: true
    }
  },
  dialogButton: {
    accept: {
      text: true
    },
    cancel: {
      text: true,
      gray: true
    }
  },
  dialogLabel: {
    primary: true
  },
  topbar: {
    link: 'https://www.edenor.com/',
    withLogo: false,
    withLogout: false,
    withLogOutCustomIcon: false
  },
  footer: {
    enabled: true
  },
  turns: {
    clientNumberRequired: true,
    createTurnsEnabled: false,
    withAssignment: false,
    withLastActivity: false
  },
  forms: {
    clientNumberLength: 10,
    nameMaxLength: 999,
    lastNameMaxLength: 999,
    phoneLength: 11,
    phoneFieldWithAreaCode: true,
    clientNumberNormalizer: normalizeByRegex(/^[0-9]{0,10}$/),
    clientNumberPatternValidation: /^[0-9]{10}$/,
    docTypes: {
      dni: true,
      cuit: true,
      provincialCi: true,
      identityCard: true,
      enlistmentBook: true,
      passport: true,
      civicNotebook: true
    }
  },
  fontFamily: 'Nunito',
  defaultRoute: DIGITAL_BILL,
  contactInformation: {
    emailRequired: true
  },
  applicationRefresh: {
    url: `${window.origin}/static/js/`,
    forceReload: true,
    withAlertAction: true,
    alertDispatcher: () => AlertHandler.error(i18n.t('Commons:refreshing')),
    pollingTime: 3600000
  },
  offices: {
    officeTag: {
      withOfficeCity: true
    }
  },
  customerInfo: {
    nameInfo: {
      enabled: false
    }
  }
};
